import React from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import { useTranslation } from 'react-i18next'
import { TableHeader, DataMessage } from '..'
import UserInviteTableRow from './UserInviteTableRow'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 1400
  },
  smallSpacer: {
    height: '0.25rem'
  },
  spacer: {
    height: '1rem'
  }
}))

function UserInviteTable (props) {
  const classes = useStyles()
  const { t } = useTranslation()

  const renderRows = () => {
    if (props.users) {
      return props.users.map((user) => (
        <React.Fragment key={user.id}>
          <div className={classes.spacer} />
          <UserInviteTableRow
            user={user}
            inviteUser={props.inviteUser}
            deleteInvite={props.deleteInvite}
          />
        </React.Fragment>
      ))
    }
    return null
  }

  return (
    <>
      <Table classes={{ root: classes.root }}>
        <TableHeader columnNames={[t('email'), t('role'), t('valid_until'), t('actions')]} />
        <div className={classes.smallSpacer} />
        <TableBody>{renderRows()}</TableBody>
      </Table>
      <DataMessage data={props.users} message={t('no_invites')} />
    </>
  )

}

export default UserInviteTable
